<template>
    <div>
        <Form ref="form" :model="formData">
            <FormItem
                label="ERP SKU生成配置"
                :rules="required"
                prop="autogenErpsku"
            >
                <RadioGroup v-model="formData.autogenErpsku">
                    <Radio :label="1">自动</Radio>
                    <Radio :label="0">手动</Radio>
                </RadioGroup>
            </FormItem>
            <Row v-if="formData.autogenErpsku">
                <Col span="18">
                    <FormItem
                        label="产品编码前缀"
                        :lableWidth="100"
                        prop="pcpfx"
                        :rules="required"
                    >
                        <Input style="width: 70%" v-model="formData.pcpfx" />
                    </FormItem>
                </Col>
                <Col span="6">
                    <Button
                        type="primary"
                        @click="generatePcpfx"
                        >重新生成</Button
                    >
                </Col>
            </Row>
            <FormItem v-if="isShowArea" label="启用区域分仓" prop="area" :rules="required">
                <RadioGroup v-model="formData.area">
                    <Radio :label="1">Y</Radio>
                    <Radio :label="0">N</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <div class="padding-bottom-15" style="text-align: center">
            <Button class="margin-right-15" type="primary" @click="confirm"
                >确定</Button
            >
            <Button type="default" @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetPcpfx,
    HttpGetOption,
    HttpUpdateOption,
    HttpCheckPcpfx,
    HttpSystemDetail
} from "@/service/ucadm";
export default {
    props: ["id"],
    data() {
        return {
            formData: {
                pcpfx: "",
                autogenErpsku: "",
                area: 0
            },
            required: {
                required: true,
                message: "该项不能为空，请填写",
            },
            checkPcpfxValid: true,
            isShowArea: false,
            loading: true
        };
    },
    async created() {
        this.isShowArea = this.handleAuth('uc.organization_option.area_set');
        await this.getOrgData();
        await this.getOption();
        this.loading = false;
    },
    methods: {
        async getOrgData () {
            await HttpSystemDetail({
                id: this.id
            }).then(res => {
                console.log(res);
                this.formData.pcpfx = res.data.entity.pcpfx;
            }, err => {
                this.$VMessage(err.message);
            })
        },
        // 获取配置
        async getOption() {
            await HttpGetOption({
                id: this.id,
                optionName: "autogen_erpsku",
                hostId: -1,
                globalDefault: 1,
            }).then(
                (res) => {
                    if (!res.data) return;
                    this.formData.autogenErpsku = parseInt(
                        res.data.optionValue
                    );
                    console.log(this.formData.autogenErpsku);
                },
                (err) => {
                    console.log(err);
                }
            );
            if (this.isShowArea) {
                await HttpGetOption({
                    id: this.id,
                    optionName: "pms_area_warehouse",
                    hostId: -1,
                    globalDefault: 1,
                }).then(
                    (res) => {
                        if (!res.data) return;
                        this.formData.area = parseInt(
                            res.data.optionValue
                        );
                        console.log(this.formData.area);
                    },
                    (err) => {
                        console.log(err);
                    }
                );
            }
        },
        // 生成产品前缀编码
        async generatePcpfx() {
            await HttpGetPcpfx({
                pcpfx: '',
            }).then(
                (res) => {
                    console.log(res);
                    this.formData.pcpfx = res.data.pcpfx;
                    this.checkPcpfxValid = true;
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        // 确定
        async confirm() {
            let flag = true;
            await this.$refs.form.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;

            if (this.formData.autogenErpsku) {
                if (
                    this.formData.pcpfx.length > 4 ||
                    !/[A-Za-z0-9]/.test(this.formData.pcpfx)
                ) {
                    return this.$VMessage.error(
                        "产品编码前缀最多为4位的字母或数字"
                    );
                }
                this.loading = true;
                await HttpCheckPcpfx({
                    pcpfx: this.formData.pcpfx,
                    excludeId: this.id,
                }).then(
                    (res) => {
                        flag = !res.data;
                    },
                    (err) => {
                        this.$VMessage.error(flag);
                    }
                );
                this.loading = false;
                if (!flag)
                    return this.$VMessage.error(
                        "产品编码前缀未通过验证，请修改或重新生成"
                    );
            }
            this.loading = true;
            await HttpUpdateOption({
                id: this.id,
                optionAutoGenErpsku: this.formData.autogenErpsku,
                pcpfx: this.formData.pcpfx,
                optionArea: this.formData.area
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style>
</style>